import { render, staticRenderFns } from "./SetupVodacomDeviceType.vue?vue&type=template&id=6e836708"
import script from "./SetupVodacomDeviceType.vue?vue&type=script&lang=js"
export * from "./SetupVodacomDeviceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports